"use client"

import { useTranslations } from "next-intl"

import { Button, EmptyState, RefreshIcon } from "@/components/ui"

export const ListingError = ({ onRetry }: { onRetry?: () => void }) => {
  const t = useTranslations("search")
  return (
    <EmptyState
      icon={<RefreshIcon size={28} />}
      title={t("error.title")}
      action={
        onRetry ? (
          <Button variant="primary" size="md" onClick={onRetry}>
            {t("error.retry")}
          </Button>
        ) : undefined
      }
    >
      {t("error.body")}
    </EmptyState>
  )
}
